module.exports = __webpack_public_path__ + "static/media/muinsuskaitseamet_logo.7dd4e760.svg";